import React from 'react';
import DialogMessage from '../../Dialog';
import { renderToString } from 'react-dom/server'
import { prettyDate } from '../../../utils/date';

const capitalize = (s) => {
   if (typeof s !== 'string') return ''
   return s.charAt(0).toUpperCase() + s.slice(1)
}

const activeSchedulingsStructure = (data) => {
    return (
        <>
            <strong style={{fontSize: '1.3em', textAlign: 'center', width: '100%', display: 'block'}}>
            {data?.message}
            </strong>
            <hr />
            <table style={{width: '100%'}}
               data-cy="table-plants-remove"
               id="table-plants-remove"
            >
                <thead>
                    <tr>
                        <th style={{ textAlign: 'left' }}>ID</th>
                        <th style={{ textAlign: 'left' }}>Data</th>
                        <th style={{ textAlign: 'left' }}>Placa</th>
                        <th style={{ textAlign: 'left' }}>Motorista</th>
                        <th style={{ textAlign: 'left' }}>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {data && data.data.map((d, index) => (
                        <tr key={index}>
                            <td style={{ textAlign: 'left' }}>{d.id}</td>
                            <td style={{textAlign: 'left'}}>{prettyDate(d.scheduling_date)}</td>
                            <td style={{ textAlign: 'left' }}>{d.truck_plate}</td>
                            <td style={{textAlign: 'left'}}>{d.driver_name}</td>
                            <td style={{ textAlign: 'left' }}>{capitalize(d.schedule_status)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}

const ModalRemovePlant = ({data, ...props}) => {
    const {isOpen, closeReadingNotificationDialog} = props
    const table = renderToString(activeSchedulingsStructure(data))

    return <DialogMessage
                isOpen={isOpen}
                data-cy="plant-remove-feedback"
                id="plant-remove-feedback"
                closeReadingNotificationDialog={closeReadingNotificationDialog}
                message={table}
            >
    </DialogMessage>
}

export default ModalRemovePlant;
